import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Check, ArrowRight, CheckCircle2, ShoppingCart, Gauge } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { SEO } from '../components/shared/SEO';
export function ProductDIYKit() {
  const [selectedImage, setSelectedImage] = useState(0);
  const images = ['https://cdn.magicpatterns.com/uploads/76x41AeJfoY4b3NAgLoMt1/DIY_KIt.png', 'https://cdn.magicpatterns.com/uploads/eBdirEmDm2gYo3UiDGb4a6/CloseUp.png'];
  const features = ['Plug-and-play electric operation (no batteries)', '75-foot hose for extended reach', 'Trigger-jet spray wand', 'Siphons directly from external containers', 'Automatic 60 PSI shutoff', 'Fully customizable mounting options'];
  return <div className="bg-white" data-id="element-490">
      <SEO title="ForceX DIY Kit | Precision Pro Sprayers" description="Build it your way. The flexible solution for contractors who want to customize their setup." data-id="element-491" />

      {/* Product Hero */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20" data-id="element-492">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start" data-id="element-493">
          {/* Image Column */}
          <div className="flex flex-col gap-4" data-id="element-494">
            <div className="bg-gray-100 rounded-xl overflow-hidden aspect-square flex items-center justify-center border border-gray-200 relative" data-id="element-495">
              <img src={images[selectedImage]} alt="ForceX DIY Kit" className="w-full h-full object-contain p-4" data-id="element-496" />
            </div>

            {/* Thumbnails */}
            <div className="grid grid-cols-4 gap-4" data-id="element-497">
              {images.map((img, index) => <button key={index} onClick={() => setSelectedImage(index)} className={`bg-gray-50 rounded-lg overflow-hidden aspect-square border-2 transition-all ${selectedImage === index ? 'border-brand-yellow ring-2 ring-brand-yellow/20' : 'border-transparent hover:border-gray-300'}`} data-id="element-498">
                  <img src={img} alt={`View ${index + 1}`} className="w-full h-full object-contain p-2" data-id="element-499" />
                </button>)}
            </div>
          </div>

          {/* Content Column */}
          <div data-id="element-500">
            <div className="mb-2" data-id="element-501">
              <span className="inline-block bg-brand-yellow/20 text-brand-dark text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide" data-id="element-502">
                Intro Pricing Available
              </span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-brand-dark mb-4" data-id="element-503">
              ForceX – DIY Kit
            </h1>
            <p className="text-xl text-brand-yellow font-bold mb-6" data-id="element-504">
              Build it your way. Spray smarter. Move faster.
            </p>

            <div className="prose prose-lg text-gray-600 mb-8" data-id="element-505">
              <p data-id="element-506">
                The ForceX DIY Kit is designed for contractors who want
                flexibility without compromise. This plug-and-play electric
                sprayer pulls solution directly from any external
                container—eliminating pouring, lifting, and chemical spills.
              </p>
              <p className="mt-4" data-id="element-507">
                Mount the system to toolboxes, buckets, or custom setups. If it
                holds liquid, you can build a sprayer around it.
              </p>
            </div>

            <div className="bg-brand-light p-6 rounded-lg mb-8 border border-gray-200" data-id="element-508">
              <h3 className="font-bold text-brand-dark mb-4 text-lg" data-id="element-509">
                Key Features
              </h3>
              <ul className="space-y-3" data-id="element-510">
                {features.map((feature, index) => <li key={index} className="flex items-start" data-id="element-511">
                    <Check className="h-5 w-5 text-brand-yellow mr-3 mt-0.5 flex-shrink-0" data-id="element-512" />
                    <span className="text-gray-700" data-id="element-513">{feature}</span>
                  </li>)}
              </ul>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 items-center" data-id="element-514">
              <div className="text-3xl font-bold text-brand-dark" data-id="element-515">$639.99</div>
              <Link to="/contact" className="flex-grow sm:flex-grow-0" data-id="element-516">
                <Button variant="primary" size="lg" className="w-full sm:w-auto" data-id="element-517">
                  Buy Now
                </Button>
              </Link>
            </div>
            <p className="mt-4 text-sm text-gray-500" data-id="element-518">
              *First-time purchaser discounts available. Contact us for bulk
              pricing.
            </p>
          </div>
        </div>
      </div>

      {/* Tech Specs / Details Band */}
      <div className="bg-brand-dark text-white py-16" data-id="element-519">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-520">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center" data-id="element-521">
            <div className="p-4" data-id="element-522">
              <div className="text-brand-yellow font-bold text-4xl mb-2" data-id="element-523">
                60 PSI
              </div>
              <div className="text-gray-400" data-id="element-524">Automatic Shutoff</div>
            </div>
            <div className="p-4 border-y md:border-y-0 md:border-x border-gray-700" data-id="element-525">
              <div className="text-brand-yellow font-bold text-4xl mb-2" data-id="element-526">
                75 FT
              </div>
              <div className="text-gray-400" data-id="element-527">Reinforced Hose</div>
            </div>
            <div className="p-4" data-id="element-528">
              <div className="text-brand-yellow font-bold text-4xl mb-2" data-id="element-529">
                110V
              </div>
              <div className="text-gray-400" data-id="element-530">Corded Electric Power</div>
            </div>
          </div>
        </div>
      </div>

      {/* Automatic Pressure Control Explanation */}
      <section className="py-16 bg-white border-b border-gray-100" data-id="element-531">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-532">
          <div className="flex flex-col md:flex-row items-start gap-8" data-id="element-533">
            <div className="flex-shrink-0" data-id="element-534">
              <div className="w-16 h-16 bg-brand-yellow/10 rounded-full flex items-center justify-center" data-id="element-535">
                <Gauge className="h-8 w-8 text-brand-yellow" data-id="element-536" />
              </div>
            </div>
            <div data-id="element-537">
              <h2 className="text-2xl font-bold text-brand-dark mb-4" data-id="element-538">
                Automatic Pressure Control (60 PSI)
              </h2>
              <p className="text-gray-600 text-lg leading-relaxed" data-id="element-539">
                The ForceX system automatically builds pressure up to 60 PSI and
                then shuts off. When the spray trigger is squeezed, pressure is
                released and the pump automatically reactivates to restore
                pressure on demand. This ensures consistent spray performance,
                prevents over-pressurization, and reduces wear on the system.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* What's Included */}
      <section className="py-16 bg-white" data-id="element-540">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-541">
          <h2 className="text-3xl font-bold text-brand-dark mb-8" data-id="element-542">
            What's Included
          </h2>
          <div className="bg-brand-light p-8 rounded-xl border border-gray-200" data-id="element-543">
            <ul className="space-y-4" data-id="element-544">
              <li className="flex items-start" data-id="element-545">
                <CheckCircle2 className="h-6 w-6 text-brand-yellow mr-3 mt-0.5 flex-shrink-0" data-id="element-546" />
                <span className="text-gray-700 text-lg" data-id="element-547">
                  Plug-and-play electric pump
                </span>
              </li>
              <li className="flex items-start" data-id="element-548">
                <CheckCircle2 className="h-6 w-6 text-brand-yellow mr-3 mt-0.5 flex-shrink-0" data-id="element-549" />
                <span className="text-gray-700 text-lg" data-id="element-550">75-foot hose</span>
              </li>
              <li className="flex items-start" data-id="element-551">
                <CheckCircle2 className="h-6 w-6 text-brand-yellow mr-3 mt-0.5 flex-shrink-0" data-id="element-552" />
                <span className="text-gray-700 text-lg" data-id="element-553">
                  Adjustable trigger jet spray wand
                </span>
              </li>
              <li className="flex items-start" data-id="element-554">
                <CheckCircle2 className="h-6 w-6 text-brand-yellow mr-3 mt-0.5 flex-shrink-0" data-id="element-555" />
                <span className="text-gray-700 text-lg" data-id="element-556">
                  External siphon intake line
                </span>
              </li>
              <li className="flex items-start" data-id="element-557">
                <CheckCircle2 className="h-6 w-6 text-brand-yellow mr-3 mt-0.5 flex-shrink-0" data-id="element-558" />
                <span className="text-gray-700 text-lg" data-id="element-559">
                  Mounts to your own container or toolbox
                </span>
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Technical Specifications */}
      <section className="py-16 bg-brand-light" data-id="element-560">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-561">
          <h2 className="text-3xl font-bold text-brand-dark mb-8" data-id="element-562">
            Technical Specifications
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-563">
            <div className="bg-white p-6 rounded-lg border border-gray-200" data-id="element-564">
              <div className="font-bold text-brand-dark mb-2" data-id="element-565">Power</div>
              <div className="text-gray-600" data-id="element-566">
                Corded electric (no batteries)
              </div>
            </div>
            <div className="bg-white p-6 rounded-lg border border-gray-200" data-id="element-567">
              <div className="font-bold text-brand-dark mb-2" data-id="element-568">Hose Length</div>
              <div className="text-gray-600" data-id="element-569">75 feet</div>
            </div>
            <div className="bg-white p-6 rounded-lg border border-gray-200" data-id="element-570">
              <div className="font-bold text-brand-dark mb-2" data-id="element-571">
                Spray Control
              </div>
              <div className="text-gray-600" data-id="element-572">Trigger-controlled wand</div>
            </div>
            <div className="bg-white p-6 rounded-lg border border-gray-200" data-id="element-573">
              <div className="font-bold text-brand-dark mb-2" data-id="element-574">Pressure</div>
              <div className="text-gray-600" data-id="element-575">Automatic shutoff at 60 PSI</div>
            </div>
            <div className="bg-white p-6 rounded-lg border border-gray-200" data-id="element-576">
              <div className="font-bold text-brand-dark mb-2" data-id="element-577">
                Intake System
              </div>
              <div className="text-gray-600" data-id="element-578">External siphon</div>
            </div>
            <div className="bg-white p-6 rounded-lg border border-gray-200" data-id="element-579">
              <div className="font-bold text-brand-dark mb-2" data-id="element-580">Applications</div>
              <div className="text-gray-600" data-id="element-581">
                Mold, disinfecting, antimicrobials, degreasers
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Contractors Choose ForceX */}
      <section className="py-16 bg-white" data-id="element-582">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-583">
          <h2 className="text-3xl font-bold text-brand-dark mb-8" data-id="element-584">
            Why Contractors Choose ForceX
          </h2>
          <div className="space-y-4" data-id="element-585">
            <div className="flex items-start p-4 bg-brand-light rounded-lg border border-gray-200" data-id="element-586">
              <CheckCircle2 className="h-6 w-6 text-brand-yellow mr-4 mt-0.5 flex-shrink-0" data-id="element-587" />
              <span className="text-gray-700 text-lg" data-id="element-588">
                No hauling chemicals into tight spaces
              </span>
            </div>
            <div className="flex items-start p-4 bg-brand-light rounded-lg border border-gray-200" data-id="element-589">
              <CheckCircle2 className="h-6 w-6 text-brand-yellow mr-4 mt-0.5 flex-shrink-0" data-id="element-590" />
              <span className="text-gray-700 text-lg" data-id="element-591">
                No pouring into backpacks or small tanks
              </span>
            </div>
            <div className="flex items-start p-4 bg-brand-light rounded-lg border border-gray-200" data-id="element-592">
              <CheckCircle2 className="h-6 w-6 text-brand-yellow mr-4 mt-0.5 flex-shrink-0" data-id="element-593" />
              <span className="text-gray-700 text-lg" data-id="element-594">
                No battery failures or downtime
              </span>
            </div>
            <div className="flex items-start p-4 bg-brand-light rounded-lg border border-gray-200" data-id="element-595">
              <CheckCircle2 className="h-6 w-6 text-brand-yellow mr-4 mt-0.5 flex-shrink-0" data-id="element-596" />
              <span className="text-gray-700 text-lg" data-id="element-597">
                Faster setup and cleanup
              </span>
            </div>
            <div className="flex items-start p-4 bg-brand-light rounded-lg border border-gray-200" data-id="element-598">
              <CheckCircle2 className="h-6 w-6 text-brand-yellow mr-4 mt-0.5 flex-shrink-0" data-id="element-599" />
              <span className="text-gray-700 text-lg" data-id="element-600">
                Cleaner, more controlled spraying
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* Who It's For */}
      <section className="py-16 bg-brand-light" data-id="element-601">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-602">
          <h2 className="text-3xl font-bold text-brand-dark mb-4" data-id="element-603">
            Who It's For
          </h2>
          <p className="text-xl text-gray-600 mb-8" data-id="element-604">Ideal for:</p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-605">
            {['Mold remediation professionals', 'Pest control', 'Janitorial and sanitation crews', 'Facilities maintenance teams', 'Property managers', 'Agricultural and horticultural use', 'Specialty surface treatment contractors'].map(audience => <div key={audience} className="flex items-center p-4 bg-white rounded-lg border border-gray-200" data-id="element-606">
                <CheckCircle2 className="h-5 w-5 text-brand-yellow mr-3 flex-shrink-0" data-id="element-607" />
                <span className="text-gray-700" data-id="element-608">{audience}</span>
              </div>)}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-20 bg-brand-dark text-white" data-id="element-609">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-610">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-611">
            Stop carrying chemicals where they don't belong.
          </h2>
          <p className="text-xl text-gray-300 mb-10" data-id="element-612">
            Spray smarter with Precision Pro Sprayers.
          </p>
          <Link to="/contact" data-id="element-613">
            <Button variant="primary" size="lg" data-id="element-614">
              <ShoppingCart className="w-5 h-5 mr-2" data-id="element-615" />
              Add to Cart
            </Button>
          </Link>
        </div>
      </section>
    </div>;
}